module.exports = __webpack_public_path__ + "static/img/female-bg-tr.e8cf86c8.png";